// Import configs
import reportVatSettlementConfig from "./vatSettlement/config";
import reportBalanceConfig from "./balance/config";
import reportLedgerConfig from "./ledger/config";

// Import sheets
import ReportVatSettlementSheet from "./vatSettlement";
import ReportVatSettlementSheetDetails from "./vatSettlement/details";
import ReportBalanceSheet from "./balance";
import ReportLedgerSheet from "./ledger";

// Import headers
import ReportVatSettlementSheetHeaderDetails from "./vatSettlement/headerDetails";

// Common elements
import ReportCommonHeader from "./_common/header";
import ReportCommonTable from "./_common/table";

export const models = [reportVatSettlementConfig, reportBalanceConfig, reportLedgerConfig];

export const sheets = {
  ReportVatSettlementSheet,
  ReportVatSettlementSheetDetails,
  ReportBalanceSheet,
  ReportLedgerSheet
};

export const headers = {
  ReportVatSettlementSheetHeaderDetails
};

export const common = {
  ReportCommonHeader,
  ReportCommonTable
};
